module.exports = __webpack_public_path__ + "img/management-practitioner-4.ba4f758d.svg";